module.exports = __webpack_public_path__ + "static/img/2-1.2cab6f27.png";